import Image from 'next/image';
import imgSearchIcon from 'assets/svgs/img-search.svg';
import { SolidButton } from '../Button';
import { H2, P } from '../Text';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next/pages';

interface INoResultProps {
  title: string;
  description: string;
  showButton?: boolean;
  // An action of the page's own, under the description (WHIT-497).
  children?: React.ReactNode;
}

const NoResult: React.FC<INoResultProps> = ({
  title,
  description,
  showButton,
  children,
}) => {
  const router = useRouter();
  const { t } = useTranslation();

  return (
    <div className="flex flex-1 justify-center items-center bg-tt-white-purple">
      <div className="flex flex-col md:flex-row justify-center items-center p-8 flex-1 md:space-x-6">
        <Image
          className="ml-auto mr-auto md:ml-0 md:mr-0"
          src={imgSearchIcon}
          alt=""
        />
        <div className="inline-flex flex-col text-center md:text-left">
          <H2 className="text-tt-heading tt-gopher">{title}</H2>
          <P className="text-black max-w-sm text-wrap break-words dm-sans mt-2">
            {description}
          </P>
          {showButton && (
            <SolidButton
              onClick={() => router.push('/')}
              className="self-center md:self-start pl-4 pr-4 pt-3 pb-3 mt-4  w-full max-w-full sm:w-4/6">
              {t('Search a flight')}
            </SolidButton>
          )}
          {children}
        </div>
      </div>
    </div>
  );
};

export default NoResult;
